import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  batchId: string;
}

export const useExportScreenshots = () => {
  return useMutation({
    mutationFn: async ({ batchId }: HookProps) => {
      const { data, headers } = await request(
        {
          path: `batches/${batchId}/export-screenshots`,
          method: 'POST',
          authenticate: true,
          responseType: 'blob',
        },
        true,
      );
      const href = window.URL.createObjectURL(data);
      const link = document.createElement('a');
      link.href = href;
      const fileName = /filename="(.*)"/.exec(headers['content-disposition'])[1];
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    onSuccess: () => {
      toast.success('Successfully downloaded the batch screenshots!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error downloading the batch screenshots!');
    },
  });
};
